'use strict';

import * as Sentry from '@sentry/browser';

let Logger = null;

/**
 * Sentry http://sentry.io is a service for logging JavaScript errors during production.
 * During development this is replaced by one that just sends data to the console but
 * mimics the same API as Sentry.
 *
 * This setup code should be called for every page.
 */

export const setupLogging = function () {

  if (window.sentry_dsn) {

    // Sentry should be used during production.

    if (window.xhale_meta_data && window.xhale_meta_data.debug_modes.indexOf('sentry_session_replay') > -1) {

      // At least for now we are only adding session replay selectively.
      Sentry.init({
        dsn: window.sentry_dsn,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
          }),
        ],
      });

      console.log('sending session replay data')

    }
    else {
      Sentry.init({
        dsn: window.sentry_dsn
      });
    }

    if (window.xhale_meta_data && window.xhale_meta_data.user_id) {
      Sentry.setUser({ "id": window.xhale_meta_data.user_id });
    }

    Logger = Sentry;

  }
  else {

    // During development we should revert to logging to the console.

    Logger = {};

    Logger.captureException = function (error, options) {
      if ('extra' in options) {
        console.log(error, options.extra);
      }
      else {
        console.log(error);
      }
    }

    Logger.captureMessage = function (message, options) {
      if ('extra' in options) {
        console.log(message, options.extra);
      }
      else {
        console.log(message);
      }
    }

  }

}

export const logMessage = function (message, info) {

  if (Logger === null) {
    setupLogging();
  }

  let options = {};
  if (info) {
    options.extra = info;
  }

  Logger.captureMessage(message, options);

}

export const logError = function (error, info) {

  if (Logger === null) {
    setupLogging();
  }

  // Important, don't throw the error again as this will cause the React
  // exception to push up the stack and more of the app will stop rendering.
  // React will throw the error again when in development anyway, but if we
  // are tempted to use this function in non-React areas where throwing them
  // again could be useful we need to still handle React errors differently.

  let options = {};
  if (info) {
    options.extra = info;
  }

  Logger.captureException(error, options);

  console.log('sending error')

}
